import { render, staticRenderFns } from "./OrderTabReports.vue?vue&type=template&id=1c1d00e6&scoped=true&"
import script from "./OrderTabReports.vue?vue&type=script&lang=ts&"
export * from "./OrderTabReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d00e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
